import React from 'react'
import Accordion from 'react-bootstrap/Accordion'

function AboutPageFaq() {
    const faqs = [
        {
            q: 'When was TechDigit Solutions founded?',
            a: 'TechDigit Solutions was founded in 2020 by four professionals with backgrounds in healthcare IT and operations, based on firsthand experience of how poorly most outsourcing companies served healthcare providers.',
        },
        {
            q: 'Where is TechDigit Solutions based?',
            a: 'TechDigit Solutions operates as a remote-delivery company serving clients across the United States, with a dedicated operations team handling healthcare billing, cybersecurity, call center, and content services.',
        },
        {
            q: "Why doesn't TechDigit Solutions show founder names or photos?",
            a: 'The founding team made a deliberate choice to lead with results rather than personal branding. In industries handling sensitive data, they apply the same privacy principles to their own data as they do to client data. Founder details are shared directly on the first consultation call.',
        },
        {
            q: 'Is the first consultation with TechDigit Solutions free?',
            a: "Yes. The initial consultation is completely free with no obligation. It's a genuine conversation about your challenges—not a sales presentation.",
        },
        {
            q: 'How many clients does TechDigit Solutions serve?',
            a: 'TechDigit Solutions has served 25+ healthcare providers and businesses since 2020, maintaining a client retention rate above 95 percent.',
        },
    ]
    return (
        <div className="faq-techdigit about-page-faq td-section td-section--faq rts-faq-section rts-section-gap">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-9">
                        <div className="faq-techdigit-inner">
                            <div className="td-section-head text-center mb-5">
                                <p className="td-section-label">About TechDigit</p>
                                <h2 className="td-section-title">Common Questions About TechDigit Solutions</h2>
                                <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                            </div>
                            <div className="faq-accordion-area">
                                <Accordion defaultActiveKey="0">
                                    {faqs.map((faq, i) => (
                                        <Accordion.Item key={i} eventKey={String(i)}>
                                            <Accordion.Header>{faq.q}</Accordion.Header>
                                            <Accordion.Body>{faq.a}</Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutPageFaq
